import { render, staticRenderFns } from "./LsvaTruckEdit.vue?vue&type=template&id=80a1e47c&"
import script from "./LsvaTruckEdit.vue?vue&type=script&lang=js&"
export * from "./LsvaTruckEdit.vue?vue&type=script&lang=js&"
import style0 from "./LsvaTruckEdit.vue?vue&type=style&index=0&id=80a1e47c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./LsvaTruckEdit.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports